<template>
  <div id="englishConsentForm" class="section content">
    <!-- <div class="box"> -->
    <h1 class="title has-text-centered">{{ title }}</h1>
    <h4 class="has-text-centered">
      <b>NIHR Global Health Research Group on Psychosis outcome: Warwick-India-Canada (WIC) Network</b>
    </h4>
    <h5 class="has-text-centered">
      <b>SCARF commissioned study - School and college based interventions for early detection and referral of adolescent and young individuals with psychosis</b>
    </h5>
    <ol>
      <li>
        <p>
          I confirm that I have read and understand the
          <a href="/participation-info-hindi">Participant Information Sheet </a>
          for the above project. I have had the opportunity to consider the information and have had these answered satisfactorily.
        </p>
      </li>
      <li>
        <p>I understand that my participation is voluntary and that I am free to withdraw at any time without giving any reason.</p>
      </li>
      <li>
        <p>I consent that the data collected through the app can be used for research purpose.</p>
      </li>
      <li>
        <p>I understand that the data collected during this study will have confidentiality and anonymity will be maintained and it will not be possible to identify you from the publication.</p>
      </li>
      <li>
        <p>I understand that all information I share will be kept in a secure and confidential manner and will not be shared with anyone other than those involved in the research.</p>
      </li>
      <li>
        <p>I agree to take part in the above project.</p>
      </li>
    </ol>
    <input type="checkbox" class="is-large" id="checkbox" v-model="agreed" :disabled="disagreed" />
    <label for="checkbox" class="is-size-5">&nbsp; I agree to above points.</label><br />
    <input type="checkbox" class="is-large" id="checkbox" v-model="disagreed" :disabled="agreed" />
    <label for="checkbox" class="is-size-5">&nbsp; I disagree to above points.</label>
    <br />
    <br />
    <div class="has-text-centered" v-if="agreed">
      <button class="button is-large is-info" @click="next()">Next &gt;&gt;</button>
    </div>
    <div class="has-text-centered" v-if="disagreed">
      <div class="control control">
        <input class="input" type="text" v-model="reasonForDecline" placeholder="Please type in reason for disagreeing" :disabled="isFeedbackSend" />
      </div>
      <br />
      <button class="button is-large is-danger" @click="decline()" :disabled="isFeedbackSend">&lt;&lt; Decline</button>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'hindiConsentForm',
  data() {
    return {
      title: 'Consent Form',
      agreed: false,
      disagreed: false,
      reasonForDecline: '',
      declineMsg: 'Thanks for your feedback.',
      isFeedbackSend: false,
    };
  },
  methods: {
    next() {
      if (this.agreed) {
        this.$router.push('demographics/hindi');
      }
    },
    decline() {
      if (this.reasonForDecline === '') {
        this.$toast.open('Please provide reason for disagreeing');
        return;
      }
      this.$http
        .post('/scarf/declineTest', {
          sessionId: this.$temp.sessionCode,
          reason: this.reasonForDecline,
        })
        .then((res) => {
          if (res.data.ok === 1) {
            this.$toast.open(this.declineMsg);
            this.isFeedbackSend = true;
          }
        });
    },
  },
  created() {
    window.scroll(0, 0);
    console.log('general info created');
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/HindiConsentForm.vue